import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function LatestStudyPage({ tab, state, sort, dir }) {
  const navigate = useNavigate();
  const qs = new URLSearchParams(
    Object.entries({ tab, state, sort, dir }).filter(([, v]) => v)
  ).toString();

  useEffect(() => {
    let cancelled = false;
    const go = async () => {
      try {
        const { data } = await api.get("/dispensations");
        if (cancelled) return;
        if (Array.isArray(data) && data.length > 0) {
          // El backend ya devuelve la lista ordenada por period_end desc
          // (ver list_dispensations en server.py). El primero es el más reciente.
          const latest = data[0];
          navigate(`/dispensations/${latest.id}${qs ? `?${qs}` : ""}`, { replace: true });
        } else {
          toast.info("Todavía no has cargado ningún estudio. Sube una dispensación para empezar.");
          navigate("/upload", { replace: true });
        }
      } catch (e) {
        if (cancelled) return;
        toast.error(e?.response?.data?.detail || "No se pudo cargar el estudio más reciente");
        navigate("/history", { replace: true });
      }
    };
    go();
    return () => {
      cancelled = true;
    };
  }, [navigate, qs]);

  return (
    <div className="min-h-[60vh] grid place-items-center" data-testid="latest-study-loading">
      <div className="flex items-center gap-3 text-slate-600">
        <Loader2 className="h-5 w-5 animate-spin" strokeWidth={1.5} />
        <span className="text-sm">Abriendo tu estudio más reciente…</span>
      </div>
    </div>
  );
}
